<template>
    <v-layout column>
        <v-layout>
        <top-info-panel >
            <v-flex xs12 md12 lg6 xl5 px-2  slot="content" >
                <h4>Zoek en filter uw point of interests</h4>
                <p>Krijg een overzicht in uw point of interests en de status hiervan doormiddel van de zoekfunctie</p>
            </v-flex>
        </top-info-panel>
        </v-layout>        
        <v-layout wrap px-3 align-center justify-center class="inset">        
<!-- OVERVIEW CUSTOM FIELDS ------------------------------------------------------------------------------------>            
        <v-flex xs12 md12 lg6 xl5 pt-2>           
            <v-widget title="POI Overzicht" class="" title-text-color="">
                <v-btn fab dark  color="accent" slot="button-top-right" @click="newCustomField()">
                    <v-icon dark>add</v-icon>
                </v-btn>                  
                <v-layout slot="widget-content">
                    <v-flex xs12 mt-4>                                         
                        <v-text-field     
                            v-if="geoZoneMeta.pagination && geoZoneMeta.pagination.total_pages"                       
                            @keyup="search(vm)"
                            v-model="searchMixin.searchText"
                            prepend-inner-icon="fas fa-search"
                            dense
                            label="Zoek een locatie"
                            solo>                    
                        </v-text-field>
                        <v-pagination v-if="geoZoneMeta.pagination && geoZoneMeta.pagination.total_pages"
                            v-model="geoZoneMeta.pagination.current_page"
                            :length="geoZoneMeta.pagination.total_pages"                           
                            @input="loadPage">
                        </v-pagination>                      

                        <v-data-table :headers="gridHeaders" :items="geoZones" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr style="cursor: pointer;" @click="$router.push(`/poi-details/${props.item.id}`)">
                                <td>{{ props.item.name }}</td>                                
                                <td>{{ props.item.geoZoneType.name}}</td>
                                <td>{{ props.item.assetAmount }}</td>
                            </tr>
                        </template>
                        </v-data-table>    
                        <v-pagination v-if="geoZoneMeta.pagination && geoZoneMeta.pagination.total_pages"             
                            v-model="geoZoneMeta.pagination.current_page"
                            :length="geoZoneMeta.pagination.total_pages"                           
                            @input="loadPage">
                        </v-pagination>                            
                    </v-flex>                                          
                </v-layout>
            </v-widget>
        </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
    import * as types from "../../store/types"
    import { mapGetters } from "vuex"
    import VWidget from "../../components/global/VWidget"
    import TopInfoPanel from '../../components/global/TopInfoPanel'      
    import SearchMixin from '../../plugins/mixins/SearchWithPagerMixin'
    import moment from 'moment'

    export default {
        mixins:[SearchMixin],
        data() {
            return {
                compObj:this,
                searchText:"",
                currentPage:1, 
                gridHeaders: [
                    { text: "Naam", sortable: false },
                    { text: "Type", sortable: false },
                    { text: "Assets in zone", sortable:false}
                ],                
                selectedGeoZone: null
            }
        },
        computed: {
            ...mapGetters({
                geoZones: types.GEO_ZONES,
                geoZoneMeta: types.GEO_ZONES_META
            }),
        },
        methods: {
            selectGeoZone(gz){          
                // add customFieldTypeId 
                this.selectedGeoZone = gz
            },
            loadCustomFields(){
                this.loadPage(1)                            
            },
                       
        },
        mounted(){
            // configure mixin
            this.searchMixin.payloadData     = {}
            this.searchMixin.payloadIncludes = "geoZoneType"
            this.searchMixin.searchStore     = types.SEARCH_GEO_ZONES
            this.searchMixin.defaultStore    = types.GEO_ZONES 
            this.reset();           
       
        },
        components:{
            TopInfoPanel,
            VWidget
        }            
    }
</script>

<style scoped>

</style>